import './bootstrap';

console.log("app.js loaded");

const mobileMaxWidth = 767;
const html = document.documentElement;
const body = document.body;
const fixedHeader = document.getElementById("page_header");

const recaptchaSiteKeyMeta = document.querySelector('meta[name="recaptcha-site-key"]');
const recaptchaSiteKey = recaptchaSiteKeyMeta?.getAttribute('content');

//mobile screen size detect
window.isMobile = (window.innerWidth <= mobileMaxWidth);

window.csrfToken = () =>
{
    return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
}

const preventBodyScroll = () =>
{
    body.classList.add('noscroll');
}
const allowBodyScroll = () =>
{
    body.classList.remove('noscroll');
}

window.stripTags = (html) =>
{
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
}

//scrolling header behaviour
// TEMP: commented out to keep header always solid black — client review
// window.addEventListener('scroll', () => {
//     const scrollTop = window.scrollY || html.scrollTop;
//
//     if (scrollTop > 250) {
//         fixedHeader.classList.add("scrolled");
//     } else {
//         fixedHeader.classList.remove("scrolled");
//     }
// });
//
// window.dispatchEvent(new Event('scroll'));

//Modals
window.showModal = function(modal_id)
{
    const modal = document.querySelector("#modals_container .modal[data-modal-id=\""+modal_id+"\"");
    if (modal)
    {
        modal.classList.add("visible");
        modal.dispatchEvent(new Event('show'));
        const focusField = modal.querySelector("[data-focus-on-show-modal]");
        if (focusField)
        {
            focusField.focus();
        }
    }
}

window.hideModal = function(modal_id = null)
{
    let modals, modal_to_close;
    if (modal_id!==null)
    {
        modal_to_close = document.querySelectorAll("#modals_container .modal[data-modal-id=\""+modal_id+"\"");
    }
    else
    {
        modals = document.querySelectorAll("#modals_container .modal");

        for (let modal of modals)
        {
            const rect = modal.getBoundingClientRect();

            // Check the center point of the modal
            const centerX = rect.left + rect.width / 2;
            const centerY = rect.top + rect.height / 2;

            const topElement = document.elementFromPoint(centerX, centerY);

            // Check if the modal is the topmost at its own center
            if (modal.contains(topElement) || modal === topElement)
            {
                modal_to_close = modal;
            }
        }
    }
    modal_to_close.classList.remove("visible");
    modal_to_close.dispatchEvent(new Event('hide'));
}

window.modal = function(content,title = null, rich = false)
{
    const dynamic_modal = document.querySelector("#modals_container .modal[data-modal-id=\"dynamic\"]");
    if (!rich)
    {
        content = "<p>"+content+"</p>";
    }
    if (title==null)
    {
        title = "Message";
    }
    dynamic_modal.querySelector(".modal_header > h4 > span").innerHTML = title;
    dynamic_modal.querySelector(".modal_content").innerHTML = content;
    window.showModal('dynamic');
}

window.richModal = function(content,title = null)
{
    window.modal(content,title,true);
}

//lazy load

window.fadeLazyLoadImage = function (image)
{
    if (image.complete)
    {
        // If the image is already loaded from cache, add loaded class immediately
        image.classList.add("loaded");
    }
    else
    {
        image.addEventListener("load", () =>
        {
            image.decode().then(() => {
                image.classList.add("loaded");
            }).catch(() => {
                // If something went wrong, add loaded class anyway
                image.classList.add("loaded");
            });
        });
    }
}

window.loadReCaptcha = function (callback) {
    if (typeof grecaptcha !== 'undefined') {
        callback();
        return;
    }

    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${recaptchaSiteKey}`;
    script.async = true;
    script.defer = true;
    script.onload = callback;
    document.head.appendChild(script);
}

document.addEventListener("DOMContentLoaded", () => {

    //mobile screen size detector
    window.addEventListener('resize', () => {
        window.isMobile = (window.innerWidth <= mobileMaxWidth);
    });

    //modal show / hide events
    document.addEventListener('click',(event) => {
        if (event.target)
        {
            const modalTrigger = event.target.closest('[data-show-modal]');
            if (modalTrigger)
            {
                event.preventDefault();
                window.showModal(modalTrigger.getAttribute('data-show-modal'));
            }
        }
    });
    document.addEventListener('mousedown',(event) => { //needs mousedown for close to stop accidental drags off modal closing it
        if (event.target)
        {
            //check for clicks inside closeable modal
            const modalOuters = document.querySelectorAll("aside.modal.closeable");

            modalOuters.forEach(modalOuter => {
                if (modalOuter.contains(event.target))
                {
                    const modalInner = modalOuter.querySelector(".modal_inner");
                    if (!modalInner.contains(event.target) || event.target.classList.contains('modal_close_button'))
                    {
                        window.hideModal();
                    }
                }
            });
        }
    });

    //hide on escape being pressed
    document.addEventListener("keyup", function(event) {
        if (event.key === "Escape") {
            const modals = document.querySelectorAll("aside.modal");
            modals.forEach(modal => {
                if (modal.classList.contains("visible"))
                {
                    window.hideModal();
                }
            });
        }
    });


    //lazy loading images fade in
    document.querySelectorAll('img[loading="lazy"]').forEach(image => {
        window.fadeLazyLoadImage(image);
    });

    // Ajax Form Submissions
    (function initAjaxForms() {
        const forms = document.querySelectorAll('form[data-action-ajax]');
        if (!forms.length) return;

        const clearErrors = (form) => {
            form.querySelectorAll('.field-error, .form-error, .input-error').forEach(n => n.remove());
            form.querySelectorAll('.has_error, .error').forEach(el => el.classList.remove('has_error', 'error'));
            form.querySelectorAll('[aria-invalid="true"]').forEach(el => el.setAttribute('aria-invalid', 'false'));
        };

        const showErrors = (form, errors = {}) => {
            // Top-level summary for non-field errors
            const summary = document.createElement('div');
            summary.className = 'form-error';
            const generalErrors = [];

            Object.entries(errors || {}).forEach(([field, messages]) => {
                const msgs = Array.isArray(messages) ? messages : [String(messages)];
                // Try to find input by name
                const input = form.querySelector(`[name="${CSS.escape(field)}"]`);
                if (input && input.type !== 'hidden') {
                    const err = document.createElement('p');
                    err.className = 'field-error';
                    err.textContent = msgs[0];
                    // mark container if possible
                    const container = input.closest('.input-group, .form_group, .form-group, .field, .input');
                    (container || input).classList.add('has_error');
                    input.setAttribute('aria-invalid', 'true');
                    // insert error after the input
                    (container || input.parentElement || form).appendChild(err);
                } else {
                    generalErrors.push(...msgs);
                }
            });

            if (generalErrors.length) {
                const g = document.createElement('div');
                g.className = 'form-error';
                g.innerHTML = generalErrors.map(m => `<p>${m}</p>`).join('');
                form.prepend(g);
            }

            // Focus first invalid input
            const firstInvalid = form.querySelector('[aria-invalid="true"]');
            if (firstInvalid) firstInvalid.focus({preventScroll: false});
        };

        const showSuccess = (form, payload = {}) => {
            const title = payload.title || form.getAttribute('data-success-title') || 'Thank you';
            const message = payload.message || form.getAttribute('data-success-message') || 'Your submission has been received.';
            const html = payload.html;

            const wrapper = document.createElement('div');
            wrapper.className = 'form-success';
            wrapper.setAttribute('role', 'status');
            wrapper.setAttribute('aria-live', 'polite');
            wrapper.setAttribute('tabindex', '-1'); // allow programmatic focus
            wrapper.innerHTML = html || `<h3>${title}</h3>${message}`;

            // Replace the form with the success message
            form.replaceWith(wrapper);

            // Scroll the success message into view accounting for fixed header
            const scrollToTopOf = (el) => {
                if (!el) return;
                try {
                    const header = document.getElementById('page_header');
                    const headerOffset = header ? header.offsetHeight : 0;
                    const rect = el.getBoundingClientRect();
                    const absoluteTop = rect.top + window.pageYOffset - (headerOffset + 16); // 16px breathing room
                    window.scrollTo({ top: Math.max(absoluteTop, 0), behavior: 'smooth' });
                } catch (e) {
                    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
                try { el.focus({ preventScroll: true }); } catch (e) {}
            };

            // Allow layout/styles to settle
            setTimeout(() => scrollToTopOf(wrapper), 50);
        };

        const performAjax = async (form) => {
            clearErrors(form);

            try {
                const url = form.getAttribute('action') || window.location.href;
                let method = (form.getAttribute('method') || 'GET').toUpperCase();

                const formData = new FormData(form);
                // method spoofing via _method
                const spoof = formData.get('_method');
                if (spoof) method = String(spoof).toUpperCase();

                let fetchUrl = url;
                let fetchOpts = {
                    method,
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    credentials: 'same-origin'
                };

                if (method === 'GET' || method === 'HEAD') {
                    const qs = new URLSearchParams(formData).toString();
                    fetchUrl = qs ? `${url}${url.includes('?') ? '&' : '?'}${qs}` : url;
                } else {
                    fetchOpts.body = formData; // includes _token
                    // CSRF header fallback
                    const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
                    if (token) (fetchOpts.headers)['X-CSRF-TOKEN'] = token;
                }

                const res = await fetch(fetchUrl, fetchOpts);
                const isJson = (res.headers.get('content-type') || '').includes('application/json');
                let data = null;
                try {
                    data = isJson ? await res.json() : null;
                } catch {
                    data = null;
                }

                if (!res.ok) {
                    // Laravel may send 422 with errors
                    const errs = data && data.errors ? data.errors : {general: ['We couldn\u2019t submit your form due to a server error. Please try again, or contact us if the problem persists.']};
                    showErrors(form, errs);
                    return;
                }

                // Success path; handle conventional shapes
                if (data && (data.success || data.status === 'ok')) {

                    const url = window.location.href.toLowerCase();
                    let type = url.includes('golf') ? 'golf' : 'health';
                    type = url.includes('racquets') ? 'racquets' : type;

                    // Google Tracking
                    if (typeof window.dataLayer !== 'undefined') {
                        dataLayer.push({
                            event: 'formSubmission',
                            formType: data?.data?.analytics?.formType ?? null,
                            attributes: {
                                type: type,
                            }
                        });
                    }

                    if (data.redirect) {
                        window.location.href = data.redirect;
                        return;
                    }

                    showSuccess(form, {title: data.data.title, message: data.data.message});
                } else if (data && data.errors) {
                    showErrors(form, data.errors);
                } else {
                    // Fallback: treat as success
                    showSuccess(form, {});
                }

            } catch (err) {
                console.error('[Form AJAX] Submission error:', err);
                showErrors(form, {general: ['An unexpected error occurred. Please try again.']});
            } finally {
                // Button state is restored in the submit handler's finally block
            }
        };

        // Attach listener
        forms.forEach(form => {

            form.addEventListener('invalid', () => {
                form.classList.add('submitted');
            }, true);

            const FIELD_WRAPPER = '.input-group, .form_group, .form-group, .field, .input';
            const clearFieldError = (input) => {
                if (!input) return;
                if (input.getAttribute('aria-invalid') === 'true') {
                    input.setAttribute('aria-invalid', 'false');
                }
                const container = input.closest(FIELD_WRAPPER);
                const scope = container || input.parentElement || form;
                scope.querySelectorAll('.field-error').forEach(el => {
                    if (!container || container.contains(el)) el.remove();
                });
                if (container) container.classList.remove('has_error', 'error', 'invalid');
                const anyInvalid = form.querySelector('[aria-invalid="true"], :invalid');
                if (!anyInvalid) form.classList.remove('submitted');
            };

            // Validate clear affect
            const shouldClear = (el) => {
                if (!el) return false;
                if (el.type === 'checkbox') return el.checked;
                if (el.type === 'radio') {
                    const group = form.querySelectorAll(`input[type="radio"][name="${CSS.escape(el.name)}"]`);
                    return Array.from(group).some(r => r.checked);
                }
                if (el.tagName === 'SELECT') return el.value !== '' && el.value != null;
                const val = (el.value || '').trim();
                return el.checkValidity() || (!!val && el.hasAttribute('required'));
            };

            // Clear inputs once changed.
            const handleMaybeClear = (target) => {
                const input = target && target.closest('input, textarea, select');
                if (!input || !form.contains(input)) return;
                if (shouldClear(input)) {
                    clearFieldError(input);
                }
            };

            form.addEventListener('input', (e) => handleMaybeClear(e.target), true);
            form.addEventListener('change', (e) => handleMaybeClear(e.target), true);

            // Submit handler
            form.addEventListener('submit', async (e) => {
                e.preventDefault();
                e.stopPropagation();

                // Immediately disable the submit button to prevent double clicks
                const submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
                const prevText = submitBtn && (submitBtn.value || submitBtn.textContent);
                if (submitBtn) {
                    submitBtn.disabled = true;
                    submitBtn.setAttribute('aria-busy', 'true');
                    if ('value' in submitBtn && submitBtn.value) submitBtn.value = 'Please wait...';
                    else submitBtn.textContent = 'Please wait...';
                }

                // Prevent parallel submissions per form (race conditions when multiple forms exist)
                if (form.dataset.submitting === '1') {
                    // If already submitting, keep the button disabled; do not proceed
                    return;
                }
                form.dataset.submitting = '1';

                // Determine a stable, form-specific reCAPTCHA action for better attribution
                const recaptchaAction = (
                    form.getAttribute('data-recaptcha-action') ||
                    form.getAttribute('name') ||
                    form.id ||
                    'submit'
                ).toString().toLowerCase().replace(/[^a-z0-9_\-\.]/g, '-').slice(0, 100);

                if (form.hasAttribute('data-captcha')) {
                    const ensureToken = () => new Promise((resolve, reject) => {
                        if (!window.grecaptcha || !recaptchaSiteKey) return reject(new Error('reCAPTCHA not configured'));
                        grecaptcha.ready(() => {
                            // Use a per-form action to ensure correct association on the backend and avoid cross-form confusion
                            grecaptcha.execute(recaptchaSiteKey, {action: recaptchaAction})
                                .then(token => {
                                    let input = form.querySelector('input[name="g-recaptcha-response"]');
                                    if (!input) {
                                        input = document.createElement('input');
                                        input.type = 'hidden';
                                        input.name = 'g-recaptcha-response';
                                        form.appendChild(input);
                                    }
                                    input.value = token;
                                    resolve();
                                })
                                .catch(reject);
                        });
                    });
                    try {
                        await ensureToken();
                        await performAjax(form);
                    } catch (err) {
                        if (typeof loadReCaptcha === 'function') {
                            await new Promise(result => loadReCaptcha(async () => {
                                try {
                                    await ensureToken();
                                } catch {
                                    // Silently fail
                                }
                                result();
                            }));
                            await performAjax(form);
                        } else {
                            console.warn('[Form AJAX] reCAPTCHA not available; continuing without token.');
                            await performAjax(form);
                        }
                    } finally {
                        // Release submit lock and re-enable submit button
                        delete form.dataset.submitting;
                        if (submitBtn) {
                            submitBtn.disabled = false;
                            submitBtn.removeAttribute('aria-busy');
                            if (prevText) {
                                if ('value' in submitBtn && submitBtn.value) submitBtn.value = prevText;
                                else submitBtn.textContent = prevText;
                            }
                        }
                    }
                } else {
                    try {
                        await performAjax(form);
                    } finally {
                        // Release submit lock and re-enable submit button
                        delete form.dataset.submitting;
                        if (submitBtn) {
                            submitBtn.disabled = false;
                            submitBtn.removeAttribute('aria-busy');
                            if (prevText) {
                                if ('value' in submitBtn && submitBtn.value) submitBtn.value = prevText;
                                else submitBtn.textContent = prevText;
                            }
                        }
                    }
                }
            });
        });
    })();


});


// toggle for mobile (hamburger -> x) + nav
document.addEventListener("DOMContentLoaded", () => {
  const hamburger = document.getElementById("main_nav_hamburger");
  const mainNav = document.getElementById("main_nav");
  const fixedHeader = document.getElementById("page_header");

  if (!hamburger || !mainNav || !fixedHeader) return;

  const navItemsWithSubnav = mainNav.querySelectorAll("li.has_children");
  const backButtons = mainNav.querySelectorAll(".subnav_back");

  const isMobileNav = () => window.innerWidth < 1200;

  const hideSubNav = () => {
    navItemsWithSubnav.forEach(item => item.classList.remove("open"));
    fixedHeader.classList.remove("subnav_open");
  };

  hamburger.addEventListener("click", (e) => {
    e.preventDefault();

    const isOpen = mainNav.classList.toggle("open");
    hamburger.classList.toggle("open", isOpen);
    fixedHeader.classList.toggle("nav_open", isOpen);
    document.body.classList.toggle("noscroll", isOpen);

    if (!isOpen) {
      hideSubNav();
    }
  });

  navItemsWithSubnav.forEach((item) => {
    const trigger = item.querySelector(":scope > a");

    if (!trigger) return;

    trigger.addEventListener("click", (e) => {
      if (!isMobileNav()) return;

      e.preventDefault();

      navItemsWithSubnav.forEach(other => {
        if (other !== item) other.classList.remove("open");
      });

      item.classList.add("open");
      fixedHeader.classList.add("subnav_open");
    });
  });

  backButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      hideSubNav();
    });
  });
});

// footer mobile accordion
function footerAccordionHandler() {

  const triggers = document.querySelectorAll('.footer-accordion-trigger');

  triggers.forEach(trigger => {
    trigger.addEventListener('click', () => {

      const targetId = trigger.dataset.target;
      const content = document.querySelector(
        `.footer-accordion-content[data-id="${targetId}"]`
      );

      if (!content) return;

      trigger.classList.toggle('open');
      content.classList.toggle('open');
    });
  });
}

document.addEventListener('DOMContentLoaded', footerAccordionHandler);